import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import Selectors from '../selectors';
import Actions from '../action';
import LoadingPresentational from './loading-presentational';

import { getAuthToken, getAuthKey } from '@helpers';
let authToken = getAuthToken();
let authKey = getAuthKey();

const LoadingFunctional = ({ appLoading, getUser, appLoader }) => {
	useEffect(() => {
		if (authKey && authToken) appLoading();
		else getUser();
	}, []);
	return <LoadingPresentational appLoader={appLoader} />;
};

const mapStateToProps = (state) => {
	return {
		appLoader: Selectors.appLoader(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		appLoading: () => dispatch(Actions.creators.appLoading()),
		getUser: () => dispatch(Actions.creators.getUser()),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(LoadingFunctional);

export default Connected;
